window.addEventListener('DOMContentLoaded', () => {
    'use strict';

    /**
     * Link to open a Tab from another page.
     * Checks for tab ID in the URL.
     */
    const externalTabLinks = () => {
        if (typeof bootstrap.Tab !== 'function') return;

        const hash = window.location.hash;
        if (!hash) return;

        const tabElement = document.querySelector('.nav-tabs >' + hash);
        if (!tabElement) return;

        // Open tab
        new bootstrap.Tab(tabElement).show();

        // Scroll to tab
        tabElement.closest('.ucphcontenttab_tab').scrollIntoView();
    };

    externalTabLinks();
});